var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('custom-animation',{staticClass:"tick",attrs:{"data":_vm.animationData,"speed":"0.5","custom":"top: 35%; left: 48%;"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }